export enum RoutesEnum {
  GET_STARTED = '/',
  LOGIN = '/login',
  ONBOARDING = '/onboarding',
  GET_STARTED_BILLING = '/getting-started/billing',
  GET_STARTED_BILLING_COMPLETE = '/getting-started/billing/complete',
  GET_STARTED_SSO = '/getting-started/sso',
  GET_STARTED_ORG_CHART = '/getting-started/org-chart',
  GET_STARTED_COMMUNICATION_TOOL = '/getting-started/communication-tool',
  DAILY_SURVEY_OVERVIEW = '/daily-survey-overview',
  QUESTION_HiSTORY = '/question-history',
  QUESTION_HISTORY_ENPS_DETAILS = '/question-history/enps',
  QUESTION_HiSTORY_DETAILS = '/question-history/:id',
  LEADER_INSIGHTS = '/leader-insights',
  LEADER_INSIGHTS_DETAILS = '/leader-insights/:id',
  DATA_EXPLORER = '/data-explorer',
  DATA_EXPLORER_DETAILS = '/data-explorer/:id',
  DATA_EXPLORER_BUILDER = '/data-explorer/builder',
  MANAGEMENT = '/management',
  MANAGEMENT_QUESTION_LIBRARY = '/management-question-library',
  MANAGEMENT_QUESTION_LIBRARY_DETAILS = '/management-question-library/:id',
  MANAGEMENT_QUESTION_SCHEDULE = '/management-question-schedule',
  SURVEYS_OVERVIEW = '/surveys-overview',
  SURVEYS_OVERVIEW_DETAILS = '/surveys-overview/:id',
  SURVEYS_OVERVIEW_BUILDER = '/surveys-overview/builder',
  SURVEYS_OVERVIEW_TEMPLATES = '/surveys-overview/templates',
  SURVEYS_TEMPLATES = '/templates',
  SETTINGS = '/settings',
  HELP = '/help',
  PROFILE = '/profile',
  INTEGRATIONS = '/integrations',
  INTEGRATIONS_SSO = '/integrations/sso',
  INTEGRATIONS_ORG_CHAT = '/integrations/org-chat',
  INTEGRATIONS_COMMUNICATION_TOOL = '/integrations/communication-tool',
  INTEGRATIONS_BILLING = '/integrations/billing',
  ACCOUNT_SETTINGS = '/account-settings',
}
